import { render, staticRenderFns } from "./bandwidth.vue?vue&type=template&id=6f17aaa4&scoped=true&"
import script from "./bandwidth.vue?vue&type=script&lang=js&"
export * from "./bandwidth.vue?vue&type=script&lang=js&"
import style0 from "./bandwidth.vue?vue&type=style&index=0&id=6f17aaa4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f17aaa4",
  null
  
)

export default component.exports